<template>
	<div class="panel panel-inverse" ref="panel">
		<slot />
	</div>
</template>
